export default __webpack_public_path__ + "static/media/cc_logo.06d7c8f7.png";